import { render, staticRenderFns } from "./CreateCustomerForm.vue?vue&type=template&id=e5171638&"
import script from "./CreateCustomerForm.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports